import { useDispatch, useSelector } from "react-redux"
import { loadOperations, selectOperations, selectShowOperationsPanel } from "../../services/global/globalSlice"

import close_img from '../../assets/images/minimize.svg'
import video_img from '../../assets/images/folders/video.svg'
import folder_img from '../../assets/images/folders/folder.svg'
import users_img from '../../assets/images/folders/users.svg'

import './OperationsPanel.css'
import { Spinner } from "react-bootstrap"
import { useEffect, useState } from "react"
import { selectTranslations } from "../../services/i18n/i18nSlice"

export default function OperationsPanel(){

    const showOperationsPanel = useSelector(selectShowOperationsPanel)
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const operations = useSelector(selectOperations)
    const [showPanel, setShowPanel] = useState(true)

    useEffect(()=>{
        if(operations?.filter(o=> o?.type !== "question_generation")?.length > 0)
            setTimeout(()=>{
                dispatch(loadOperations())
            }, 60000)
    },[operations])

    return (
        <>
            {operations?.filter(o=> o?.type !== "question_generation")?.length > 0 &&
                <div id="operations_panel" className={!showPanel ? "closed" : ""}>
                    {
                        showPanel ?
                            <>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h3 className="d-flex align-items-center text-tf mb-0"><Spinner style={{width:'24px', height:'24px'}} className="me-2"/> Attività in background</h3>
                                    <img src={close_img} style={{width:"26px"}} className="ms-3 pointer" onClick={()=>{setShowPanel(false)}}/>
                                </div>
                                {
                                    operations?.map((operation, index) => {
                                        return(
                                            <div key={index} className="border-bottom border-bottom-2 pb-2 mt-2 d-flex align-items-center justify-content-between">
                                                {
                                                    operation.entity_kind_name === "video_registry" && <img src={video_img} />
                                                }
                                                {
                                                    operation.entity_kind_name === "folder" && <img src={folder_img} />
                                                }
                                                <div className="d-flex flex-column ms-3">
                                                   {
                                                        operation.type === "update_permissions" && <span >{t.operations.type[operation?.type] || operation?.type}</span>
                                                    }
                                                    {
                                                        operation?.entity?.actual_filename && <span >{operation?.entity?.actual_filename}</span>
                                                    }
                                                    {
                                                        operation?.entity?.name && <small >{operation?.entity?.name}</small>
                                                    } 
                                                </div>
                                                <span className="text-warning ms-4"> {t.operations.state[operation?.state] || operation?.state}</span>
                                            </div>
                                        )
                                    })
                                }
                            </> : <>
                                <Spinner className="text-tf pointer mb-0" onClick={()=>{setShowPanel(true)}} />
                            </>
                    }
                </div>          
            }   
        </>
    )
}